<template>
	<div class="item">
		<div
			class="image-wrapper"
			:style="{ backgroundImage: `url(${image})` }"
		></div>
		<div class="content-wrapper">
			<div class="item-vendor" v-text="properties.designer" />
			<div class="item-title" v-text="title" />
			<div class="item-price">
				<span v-if="discounted_price == price">{{
					$formatMoney(price)
				}}</span>
				<p v-else>
					<span class="original_price">{{
						$formatMoney(price)
					}}</span>
					{{ $formatMoney(discounted_price) }}
				</p>
			</div>
			<div class="quantity">
				<p>{{ translation.item_quantity }}</p>
				<a class="change" @click="change('subtract')">-</a>
				<div class="amount" v-text="quantity" />
				<a class="change" @click="change('add')">+</a>
			</div>
		</div>
		<div class="remove" @click="change('remove')">
			<p>
				{{ translation.remove
				}}<span>
					<svg
						width="16px"
						height="16px"
						viewBox="0 0 16 16"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
					>
						<g
							id="Symbols"
							stroke="none"
							stroke-width="1"
							fill="none"
							fill-rule="evenodd"
						>
							<g
								id="UI/CartRemove"
								transform="translate(1.000000, 1.000000)"
								fill-rule="nonzero"
								stroke="#969BA5"
							>
								<circle id="Oval" cx="7" cy="7" r="7"></circle>
								<path
									d="M2.5,7 L11.6376953,7"
									id="Line-6"
									stroke-linecap="square"
								></path>
							</g>
						</g></svg
				></span>
			</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: { type: String, required: true },
		quantity: { type: Number, required: true },
		variant_id: { type: Number, required: true },
		price: { type: Number, required: true },
		image: { type: String, required: true },
		properties: { type: Object, required: true },
		discounted_price: { type: Number, required: true }
	},
	data() {
		return {
			translation: this.$translations.cart
		};
	},
	methods: {
		async change(action) {
			const quantity =
				action === "add"
					? this.quantity + 1
					: action === "remove"
					? 0
					: this.quantity - 1;

			try {
				await this.$store.dispatch("cart/change", {
					id: this.variant_id,
					quantity
				});
			} catch (error) {
				console.log(error.message);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.item {
	border-top: 1px solid #eeeeee;
	border-bottom: 1px solid #eeeeee;
	padding: 20px 0;
	display: flex;

	.image-wrapper {
		background-size: cover;
		background-position: center;
		width: 110px;
		height: 110px;
		margin-right: 25px;
	}

	.content-wrapper {
		color: $dark-grey;
		position: relative;
		flex: 1;

		.item- {
			&vendor {
				font-family: $font-text;
				font-size: 14px;
				line-height: 20px;
			}

			&title,
			&price {
				color: #2d384c;
				font-size: 11px;
				opacity: 0.5;
				margin-top: 4px;

				.original_price {
					text-decoration: line-through;
					margin-right: 10px;
				}
			}
		}

		.quantity {
			position: absolute;
			bottom: 0;
			color: $brown;
			font-family: $font-text-heavy;
			display: flex;
			align-items: center;
			font-size: 12px;
			font-weight: 800;

			p {
				margin-right: 10px;
				letter-spacing: -0.2px;
			}

			.amount {
				margin: 0 4px;
			}

			.change {
				cursor: pointer;
			}
		}
	}

	.remove {
		margin-left: auto;
		color: $medium-grey;
		font-family: $font-text;
		font-size: 10px;
		font-weight: 400;
		line-height: 12px;
		cursor: pointer;
		display: inline-block;

		p {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		span {
			width: 11px;
			height: 11px;
			margin-left: 5px;
			cursor: pointer;

			svg {
				width: 11px;
				height: 11px;
			}
		}
	}
}
</style>

